module.exports = __webpack_public_path__ + "img/booking.d0777fed.png";